import { IconButton, styled } from '@mui/material';

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  alignSelf: 'flex-start',
  padding: 0,
  color: theme.palette.grey[200],
}));
